import { styled } from '@mui/material';

const LogoImage = styled('img')({
  width: 'auto',
  height: '100%',
  maxHeight: '80px',
});

const IconImage = styled('img')({
  width: '42px',
  height: '42px',
});

export { LogoImage, IconImage };
